export const FORM_ADMINISTRATION_DATA_REQUEST =
  'FORM_ADMINISTRATION_DATA_REQUEST';
export const FORM_ADMINISTRATION_DATA_SUCCESS =
  'FORM_ADMINISTRATION_DATA_SUCCESS';
export const FORM_ADMINISTRATION_DATA_FAIL = 'FORM_ADMINISTRATION_DATA_FAIL';
